import { LevelProgress } from "@/modules/theme/components/LevelProgress/LevelProgress";
import { StepStatus } from "@/modules/theme/components/StepStatus/StepStatus";
import { useTheme } from "@/modules/theme/hooks/useTheme";
import { useUserDataContext } from "@/modules/user/hooks/useUserDataContext";

import { FirstLoadingLevelsView } from "../FirstLoadingLevelsView";

import { EmptyLevelsView } from "./EmptyLevelsView";
import { createLevelsListStyles } from "./helpers/createLevelsListStyles";
import { useGetLevelsQuery } from "./helpers/useGetLevelsQuery";
import { useMapLevelsRequirements } from "./helpers/useMapLevelsRequirements";

export const LevelsList = () => {
  const classes = createLevelsListStyles(useTheme());

  const {
    data: levels,
    isLoading: isLevelsDataLoading,
    isSuccess: isLevelsDataFetched,
  } = useGetLevelsQuery();
  const { currentAchievements } = useUserDataContext();
  const currentUserLevel = currentAchievements?.levelOrder;

  const isLevelsListEmpty = !levels?.length && isLevelsDataFetched;

  const mappedLevels = useMapLevelsRequirements(levels, currentUserLevel);

  if (isLevelsListEmpty) {
    return <EmptyLevelsView />;
  }

  if (isLevelsDataLoading) {
    return <FirstLoadingLevelsView />;
  }

  return (
    <div className={classes.root}>
      {mappedLevels?.map((level) => {
        const {
          progress,
          areAllRequirementsCompleted,
          requirements,
          isLevelActive,
          order,
        } = level;

        return (
          <div className={classes.level} key={order}>
            <div>
              <LevelProgress
                level={level.order + 1}
                active={isLevelActive}
                progress={isLevelActive ? progress : 0}
                done={areAllRequirementsCompleted}
                className={classes.levelIcon}
              />
              <ul className={classes.requirements}>
                {Object.values(requirements).map(({ isCompleted, label }) => (
                  <li className={classes.requirement} key={label}>
                    <StepStatus done={isLevelActive ? isCompleted : false} />
                    {label}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        );
      })}
    </div>
  );
};
